import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const AudioCirclePlayerWrapper = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  cursor: pointer;
`

export const AudioCirclePlayerControllers = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &:hover {
    path {
      fill: ${COLORS.secondarySemiDark};
    }
  }
`

export const ResumeIcon = styled.div<{ size: number; color?: string }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 1px;
  background-color: ${props => props.color || COLORS.secondary};

  &:hover {
    background-color: ${props => props.color || COLORS.secondarySemiDark};
  }
`
